import { useState, useEffect, useContext, useRef } from "react";
import DataTable from "react-data-table-component";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import HeaderDashboard from "../../Components/HeaderDashboard";
import $ from "jquery";
import "jquery-ui-dist/jquery-ui";
import "jquery-ui-dist/jquery-ui.css";
import { AuthContext } from "../../Routes/AuthProvider";
import { getAllHotelBookings } from "../../Services/HotelSearchApi";
import * as XLSX from "xlsx";

const AllTransactions = () => {
  const { userName, roles } = useContext(AuthContext);
  const isCorpTravel = roles?.includes("Corporate Traveller");
  
  const tableWrapperRef = useRef(null);

  const [filters, setFilters] = useState({
    fromDate: "",
    toDate: "",
    bookingRefNo: "",
    bookingStatus: "",
    paymentStatus: "",
    hotelName: "",
    hotelPNR: "",
  });

  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [hasSearched, setHasSearched] = useState(false);
  const [visibleColumns, setVisibleColumns] = useState([]);
  const [hiddenColumns, setHiddenColumns] = useState([]);
  const [filterText, setFilterText] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({ ...prev, [name]: value }));
  };

  const convertToDate = (str) => {
    if (!str) return null;
    const [day, month, year] = str.split("/");
    return new Date(`${year}-${month}-${day}`);
  };

  const formatDateForApi = (dateStr, isEnd = false) => {
    if (!dateStr) return undefined;
    const dateObj = convertToDate(dateStr);
    if (!dateObj || isNaN(dateObj.getTime())) return undefined;

    const pad = (num) => String(num).padStart(2, '0');
    const year = dateObj.getFullYear();
    const month = pad(dateObj.getMonth() + 1);
    const day = pad(dateObj.getDate());
    const hours = isEnd ? "23" : "00";
    const minutes = isEnd ? "59" : "00";
    const seconds = isEnd ? "59" : "00";
    return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
  };

  useEffect(() => {
    $("#fromDate").datepicker({
      dateFormat: "dd/mm/yy",
      maxDate: 0,
      onSelect: function (dateText) {
        setFilters((prev) => ({
          ...prev,
          fromDate: dateText,
        }));
      },
    });

    $("#toDate").datepicker({
      dateFormat: "dd/mm/yy",
      maxDate: 0,
      onSelect: function (dateText) {
        setFilters((prev) => ({
          ...prev,
          toDate: dateText,
        }));
      },
    });
  }, []);

  useEffect(() => {
    if (filters.fromDate) {
      const minD = convertToDate(filters.fromDate);
      $("#toDate").datepicker("option", "minDate", minD);
    }
  }, [filters.fromDate]);

  const handleSearch = async () => {
    setLoading(true);
    setHasSearched(true);
    try {
      const fromDateParam = formatDateForApi(filters.fromDate, false);
      const toDateParam = formatDateForApi(filters.toDate, true);
      const data = await getAllHotelBookings(
        userName,
        filters.bookingStatus,
        filters.paymentStatus,
        fromDateParam,
        toDateParam,
        filters.hotelPNR,
        filters.bookingRefNo,
        filters.hotelName
      );

      let list = [];
      if (Array.isArray(data)) {
        list = data;
      } else if (data?.bookings && Array.isArray(data.bookings)) {
        list = data.bookings;
      } else if (
        data?.data?.allHotelBookings &&
        Array.isArray(data.data.allHotelBookings)
      ) {
        list = data.data.allHotelBookings;
      } else if (data?.data && Array.isArray(data.data)) {
        list = data.data;
      } else if (data?.allTransactions && Array.isArray(data.allTransactions)) {
        list = data.allTransactions;
      } else if (
        data?.allHotelBookings &&
        Array.isArray(data.allHotelBookings)
      ) {
        list = data.allHotelBookings;
      } else if (
        data?.data?.allTransactions &&
        Array.isArray(data.data.allTransactions)
      ) {
        list = data.data.allTransactions;
      }

      //console.log("Extracted List:", list);

      // Apply client-side filters
      if (filters.bookingRefNo) {
        list = list.filter((item) => {
          const ref = (
            item.bookingRefId ||
            item.BookingRefId ||
            item.confirmationNo ||
            item.ConfirmationNo ||
            item.referenceNo ||
            item.ReferenceNo ||
            ""
          ).toLowerCase();
          return ref.includes(filters.bookingRefNo.toLowerCase());
        });
      }
      if (filters.hotelPNR) {
        list = list.filter((item) => {
          const pnr = (
            item.hotelPNR ||
            item.HotelPNR ||
            item.confirmationNo ||
            item.ConfirmationNo ||
            item.pnr ||
            item.PNR ||
            ""
          ).toLowerCase();
          return pnr.includes(filters.hotelPNR.toLowerCase());
        });
      }
      if (filters.hotelName) {
        list = list.filter((item) => {
          const hotel = (item.hotelName || item.HotelName || "").toLowerCase();
          const city = (item.cityName || item.CityName || "").toLowerCase();
          const search = filters.hotelName.toLowerCase();
          return hotel.includes(search) || city.includes(search);
        });
      }
      if (filters.bookingStatus) {
        list = list.filter((item) => {
          const status = (item.bookingStatus || item.BookingStatus || "").toUpperCase();
          return status === filters.bookingStatus.toUpperCase();
        });
      }
      if (filters.paymentStatus) {
        list = list.filter((item) => {
          const status = (item.paymentStatus || item.PaymentStatus || "").toUpperCase();
          return status === filters.paymentStatus.toUpperCase();
        });
      }
      if (filters.fromDate || filters.toDate) {
        const fromLimit = filters.fromDate ? convertToDate(filters.fromDate) : null;
        if (fromLimit) fromLimit.setHours(0, 0, 0, 0);

        const toLimit = filters.toDate ? convertToDate(filters.toDate) : null;
        if (toLimit) toLimit.setHours(23, 59, 59, 999);

        list = list.filter((item) => {
          const itemDateStr = item.createdAt || item.CreatedAt || item.bookingDate || item.BookingDate;
          if (!itemDateStr) return false;
          const itemDate = new Date(itemDateStr);
          if (isNaN(itemDate.getTime())) return false;

          if (fromLimit && itemDate < fromLimit) return false;
          if (toLimit && itemDate > toLimit) return false;
          return true;
        });
      }

      setTransactions(list);
    } catch (error) {
      console.error("Error fetching hotel transactions:", error);
      alert("Failed to fetch transactions. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (userName) {
      handleSearch();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userName]);

  const formatDateDisplay = (dateStr) => {
    if (!dateStr) return "-";
    try {
      const date = new Date(dateStr);
      return date.toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      });
    } catch (e) {
      return dateStr;
    }
  };

  const formatDateTimeDisplay = (dateStr) => {
    if (!dateStr) return "-";
    try {
      const date = new Date(dateStr);
      return date.toLocaleString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      });
    } catch (e) {
      return dateStr;
    }
  };

  const filteredItems = transactions.filter((item) => {
    if (!filterText) return true;
    const term = filterText.toLowerCase();
    const ref = (
      item.bookingRefId ||
      item.BookingRefId ||
      item.referenceNo ||
      item.ReferenceNo ||
      ""
    ).toLowerCase();
    const status = (item.bookingStatus || item.BookingStatus || "").toLowerCase();
    const conf = (item.confirmationNo || item.ConfirmationNo || "").toLowerCase();
    const pnr = (item.hotelPNR || item.HotelPNR || item.pnr || item.PNR || "").toLowerCase();
    const hotel = (item.hotelName || item.HotelName || "").toLowerCase();
    const guest = (item.guestName || item.PassengerName || item.Passenger || "").toLowerCase();
    const entity = (item.gstName || "").toLowerCase();
    return (
      ref.includes(term) ||
      status.includes(term) ||
      conf.includes(term) ||
      pnr.includes(term) ||
      hotel.includes(term) ||
      guest.includes(term) ||
      entity.includes(term)
    );
  });

  const handleExportExcel = () => {
    const dataToExport = filteredItems.map((item, index) => ({
      "Sr No": index + 1,
      "Ref No": item.bookingRefId || item.BookingRefId || item.referenceNo || item.ReferenceNo || "",
      "Entity Name": item.gstName || "",
      "Pax Name": item.rooms?.flatMap((room) => room.paxDetails || [])
        .map((pax) => `${pax.firstName || ""} ${pax.lastName || ""}`.trim())
        .filter(Boolean).join(", ") || "",
      "Booking Date": item.createdAt || item.CreatedAt || item.bookingDate || item.BookingDate
        ? new Date(item.createdAt || item.CreatedAt || item.bookingDate || item.BookingDate).toLocaleString("en-GB", {
            day: "2-digit",
            month: "short",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
          })
        : "",
      "City": item.cityName || "",
      "Hotel": item.hotelName || "",
      "Check-in": item.checkInDate ? new Date(item.checkInDate).toLocaleString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      }) : "",
      "Check-out": item.checkOutDate ? new Date(item.checkOutDate).toLocaleString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      }) : "",
      "Room": item.noOfRooms || "",
      "PNR": item.hotelPNR || item.confirmationNo || "",
      "Payment Status": item.paymentStatus || item.PaymentStatus || "",
      "Booking Status": item.bookingStatus || item.BookingStatus || "",
      "Amount": item.totalPrice || item.TotalPrice || item.amount || item.Amount || 0,
    }));

    const worksheet = XLSX.utils.json_to_sheet(dataToExport);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "AllTransactions");
    XLSX.writeFile(workbook, "All_Transactions_Report.xlsx");
  };

  // Status Badge Component
  const StatusBadge = ({ status, type = "booking" }) => {
    let bg = "#ffffff00";
    let color = "#ff1f1f";

    if (type === "payment") {
      const upperStatus = (status || "").toUpperCase();
      if (upperStatus === "SUCCESS") {
        bg = "#ffffff00";
        color = "#00a63e";
      } else if (["REQUESTED", "REFUNDED", "UNPAID"].includes(upperStatus)) {
        bg = "#ffffff00";
        color = "#ff9800";
      } else if (upperStatus === "FAILED") {
        bg = "#ffffff00";
        color = "#ff1f1f";
      } else {
        bg = "#ffffff00";
        color = "#666";
      }
    } else {
      const upperStatus = (status || "").toUpperCase();
      if (upperStatus === "CONFIRMED") {
        bg = "#ffffff00";
        color = "#00a63e";
      } else if (["PENDING", "HOLD", "CANCELLATION_PENDING", "APPROVE_PENDING"].includes(upperStatus)) {
        bg = "#ffffff00";
        color = "#ff9800";
      } else if (["FAILED", "CANCELLED", "APPROVE_REJECTED"].includes(upperStatus)) {
        bg = "#ffffff00";
        color = "#ff1f1f";
      } else {
        bg = "#ffffff00";
        color = "#666";
      }
    }

    return (
      <span
        style={{
          background: bg,
          color: color,
          padding: "3px 0px",
          borderRadius: "30px",
          fontSize: "13px",
          fontWeight: 600,
          display: "inline-block",
          minWidth: "150px",
          textAlign: "left",
        }}
      >
        {status || "-"}
      </span>
    );
  };

  // DataTable Columns Definition - ALL columns preserved
  const allColumns = [
    {
      id: "referenceNo",
      name: "REF NO.",
      selector: row => row.bookingRefId || row.BookingRefId || row.referenceNo || row.ReferenceNo || "",
      sortable: true,
      cell: row => (
        <Link
          to={`/reservations/hotel/TransactionsDetails?referenceno=${row.bookingRefId || row.BookingRefId || row.referenceNo || row.ReferenceNo}`}
          style={{
            color: "#0d47a1",
            fontWeight: "600",
            cursor: "pointer",
            textDecoration: "none"
          }}
        >
          {row.bookingRefId || row.BookingRefId || row.referenceNo || row.ReferenceNo || "-"}
        </Link>
      ),
      priority: 1,
    },
    ...(!isCorpTravel ? [
      {
        id: "entityName",
        name: "ENTITY NAME",
        selector: row => row.gstName || "-",
        sortable: true,
        grow: 2,
        cell: row => row.gstName || "-",
        priority: 2,
      },
      {
        id: "paxName",
        name: "PAX NAME",
        selector: row => {
          const pax = row.rooms?.flatMap((room) => room.paxDetails || [])
            .map((p) => `${p.firstName || ""} ${p.lastName || ""}`.trim())
            .filter(Boolean).join(", ");
          return pax || "-";
        },
        sortable: true,
        grow: 2,
        cell: row => {
          const pax = row.rooms?.flatMap((room) => room.paxDetails || [])
            .map((p) => `${p.firstName || ""} ${p.lastName || ""}`.trim())
            .filter(Boolean).join(", ");
          return pax || "-";
        },
        priority: 3,
      }
    ] : []),
    {
      id: "bookingDate",
      name: "BOOKING DATE",
      selector: row => row.createdAt || row.CreatedAt || row.bookingDate || row.BookingDate || "",
      sortable: true,
      priority: 4,
      grow: 2,
      cell: row => formatDateTimeDisplay(row.createdAt || row.CreatedAt || row.bookingDate || row.BookingDate),
    },
    {
      id: "city",
      name: "CITY",
      selector: row => row.cityName || "-",
      sortable: true,
      cell: row => row.cityName || "-",
    },
    {
      id: "hotelName",
      name: "HOTEL",
      selector: row => row.hotelName || "-",
      sortable: true,
      grow: 2,
      cell: row => row.hotelName || "-",
    },
    {
      id: "checkIn",
      name: "CHECK-IN",
      selector: row => row.checkInDate || "",
      sortable: true,
      cell: row => formatDateTimeDisplay(row.checkInDate),
    },
    {
      id: "checkOut",
      name: "CHECK-OUT",
      selector: row => row.checkOutDate || "",
      sortable: true,
      cell: row => formatDateTimeDisplay(row.checkOutDate),
    },
    {
      id: "rooms",
      name: "ROOM",
      selector: row => row.noOfRooms || "-",
      sortable: true,
      cell: row => row.noOfRooms || "-",
    },
    {
      id: "pnr",
      name: "PNR",
      selector: row => row.hotelPNR || row.confirmationNo || "-",
      sortable: true,
      cell: row => row.hotelPNR || row.confirmationNo || "-",
    },
    {
      id: "paymentStatus",
      name: "PAYMENT",
      selector: row => row.paymentStatus || row.PaymentStatus || "-",
      sortable: true,
      cell: row => <StatusBadge status={row.paymentStatus || row.PaymentStatus || "-"} type="payment" />,
      priority: 9,
    },
    {
      id: "bookingStatus",
      name: "BOOKING",
      selector: row => row.bookingStatus || row.BookingStatus || "-",
      sortable: true,
      cell: row => <StatusBadge status={row.bookingStatus || row.BookingStatus || "-"} type="booking" />,
      priority: 10,
    },
    {
      id: "amount",
      name: "AMOUNT",
      selector: row => row.totalPrice || row.TotalPrice || row.amount || row.Amount || 0,
      sortable: true,
      grow: 2,
      cell: row => (
        <span className="fw-bold">
          ₹ {(row.totalPrice || row.TotalPrice || row.amount || row.Amount || 0)?.toLocaleString()}
        </span>
      ),
    },
  ];

  // Responsive Columns Logic
  const calculateResponsiveColumns = () => {
    if (!tableWrapperRef.current) return;

    const containerWidth = tableWrapperRef.current.clientWidth;
    const expanderWidth = 85;

    const columnWidths = {
      referenceNo: 350,
      entityName: 200,
      paxName: 180,
      bookingDate: 160,
      city: 120,
      hotelName: 220,
      checkIn: 150,
      checkOut: 150,
      rooms: 80,
      pnr: 120,
      paymentStatus: 130,
      bookingStatus: 130,
      amount: 120,
    };

    let availableWidth = containerWidth - expanderWidth;
    const visible = [];
    const hidden = [];

    // First column ALWAYS visible
    visible.push(allColumns[0]);
    availableWidth -= columnWidths.referenceNo || 130;

    allColumns.slice(1).forEach(column => {
      const width = columnWidths[column.id] || 120;
      if (availableWidth >= width) {
        visible.push(column);
        availableWidth -= width;
      } else {
        hidden.push(column);
      }
    });

    setVisibleColumns(visible);
    setHiddenColumns(hidden);
  };


   const [showAd, setShowAd] = useState(false);



  useEffect(() => {
    calculateResponsiveColumns();

    const resizeObserver = new ResizeObserver(() => {
      calculateResponsiveColumns();
    });

    if (tableWrapperRef.current) {
      resizeObserver.observe(tableWrapperRef.current);
    }

    window.addEventListener("resize", calculateResponsiveColumns);

    return () => {
      resizeObserver.disconnect();
      window.removeEventListener("resize", calculateResponsiveColumns);
    };
  }, [transactions]);

  // const ExpandedComponent = ({ data }) => {
  //   return (
  //     <div className="expanded-data" style={{ padding: "15px 20px", display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(200px, 1fr))", gap: "10px", background: "#f8f9fa" }}>
  //       {hiddenColumns.map(column => (
  //         <div key={column.id} className="expanded-item" style={{ display: "flex", flexDirection: "column", padding: "5px 0" }}>
  //           <strong style={{ fontSize: "12px", color: "#666", textTransform: "uppercase", letterSpacing: "0.5px" }}>
  //             {column.name}:
  //           </strong>
  //           <span style={{ fontSize: "14px", fontWeight: "500" }}>
  //             {column.cell ? column.cell(data) : column.selector ? column.selector(data) : "-"}
  //           </span>
  //         </div>
  //       ))}
  //     </div>
  //   );
  // };
      const ExpandedComponent = ({ data }) => {
        return (
            <div className="expanded-data">
                {hiddenColumns.map(column => (
                    <div
                        key={column.id}
                        className="expanded-item"
                    >
                        <strong>
                            {column.name}:
                        </strong>

                        <span>
                            {column.cell
                                ? column.cell(data)
                                : column.selector
                                    ? column.selector(data)
                                    : "-"}
                        </span>
                    </div>
                ))}
            </div>
        );
    };

  // DataTable Custom Styles
   const customStyles = {
        table: {
            style: {
                backgroundColor: "#fff",
                borderRadius: "0px",
                overflow: "hidden",
            },
        },
        headRow: {
            style: {
                background: "#110942",
                minHeight: "55px",
                borderBottomWidth: "0",
            },
        },
        headCells: {
            style: {
                color: "#fff",
                fontSize: "14px",
                fontWeight: "600",
                textTransform: "uppercase",
            },
        },
        rows: {
            style: {
                minHeight: "60px",
                fontSize: "13px",
                borderBottom: "1px solid #eef2f7",
                '&:hover': {
                    backgroundColor: "#f4f8ff",
                    cursor: "pointer",
                },
            },
        },
        pagination: {
            style: {
                borderTop: "1px solid #eef2f7",
                minHeight: "60px",
            },
        },
    };
  return (
    <>
     
      <HeaderDashboard />

      <div className="toolbar py-2" id="kt_toolbar">
        <div className="container-fluid d-flex align-items-center">
          <div className="flex-grow-1">
            <div className="page-title d-flex align-items-center flex-wrap">
              <h1 className="text-gray-900 fw-bold fs-3">Reservations</h1>
              <span className="h-20px border-gray-200 border-start mx-3"></span>
              <ul className="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-1">
                <li className="breadcrumb-item text-muted">Hotel</li>
                <li className="breadcrumb-item">
                  <span className="bullet bg-gray-200 w-5px h-2px"></span>
                </li>
                <li className="breadcrumb-item text-gray-900">All Transactions</li>
              </ul>
            </div>
          </div>
          <div className="d-flex align-items-center flex-wrap">
            <div className="flex-shrink-0">
              <ul className="nav" role="tablist">
                <li className="nav-item" role="presentation">
                  <a href="/Dashboard">
                    <img src="/assets/images/back.png" className="imgBack" alt="back" />
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <section className="wraper">
        <div className="box_shadow mt-14">
          {/* Filter Section - ALL filters preserved */}
          <div className="row g-3">
            <div className="col-md-2">
              <label className="form-label fw-bold">From Date</label>
              <input
                type="text"
                id="fromDate"
                className="form-control"
                placeholder="From Date"
                value={filters.fromDate}
                style={{ cursor: "pointer" }}
                readOnly
              />
            </div>
            <div className="col-md-2">
              <label className="form-label fw-bold">To Date</label>
              <input
                type="text"
                id="toDate"
                className="form-control"
                placeholder="To Date"
                value={filters.toDate}
                style={{ cursor: "pointer" }}
                readOnly
              />
            </div>

           
            <div className="col-md-2 mt-11">

              <button
                type="button"
                className="btn btn-primary w-100"
                onClick={handleSearch}
                disabled={loading}
              >
                {loading ? "Loading..." : "Search"}
              </button>
             
              <p className="AdvanceSearch" onClick={() => setShowAd((prev) => !prev)}>Advance Search</p>
            </div>
             {showAd && (
                <div className="row">
                 <div className="col-md-3">
              <label className="form-label fw-bold">Hotel Name / City</label>
              <input
                className="form-control"
                type="text"
                name="hotelName"
                value={filters.hotelName}
                onChange={handleChange}
                placeholder="Search by hotel or city"
              />
            </div>
            <div className="col-md-3">
              <label className="form-label fw-bold">Hotel PNR</label>
              <input
                className="form-control"
                type="text"
                name="hotelPNR"
                value={filters.hotelPNR}
                onChange={handleChange}
                placeholder="Hotel PNR"
              />
            </div>
             <div className="col-md-2">
              <label className="form-label fw-bold">Reference No</label>
              <input
                className="form-control"
                type="text"
                name="bookingRefNo"
                value={filters.bookingRefNo}
                onChange={handleChange}
                placeholder="Ref No"
              />
            </div>
            <div className="col-md-2">
              <label className="form-label fw-bold">Booking Status</label>
              <select
                className="form-select form-control"
                name="bookingStatus"
                value={filters.bookingStatus}
                onChange={handleChange}
              >
                <option value="">-Select-</option>
                <option value="PENDING">PENDING</option>
                <option value="CONFIRMED">CONFIRMED</option>
                <option value="HOLD">HOLD</option>
                <option value="FAILED">FAILED</option>
                <option value="CANCELLATION_PENDING">CANCELLATION_PENDING</option>
                <option value="CANCELLED">CANCELLED</option>
                <option value="APPROVE_PENDING">APPROVE_PENDING</option>
                <option value="APPROVE_REJECTED">APPROVE_REJECTED</option>
              </select>
            </div>
            <div className="col-md-2">
              <label className="form-label fw-bold">Payment Status</label>
              <select
                className="form-select form-control"
                name="paymentStatus"
                value={filters.paymentStatus}
                onChange={handleChange}
              >
                <option value="">-Select-</option>
                <option value="Success">Success</option>
                <option value="Requested">Requested</option>
                <option value="Failure">Failure</option>
                <option value="Refunded">Refunded</option>
                <option value="UnPaid">UnPaid</option>
              </select>
            </div>
                </div>
              )}
           

          </div>
        </div>

        <div className="box_shadow mt-3">
          <div className="d-flex justify-content-between align-items-center mb-4 flex-wrap" style={{ gap: "15px" }}>
            <div>
              {/* <button
                className="btn btn-success btn-sm"
                onClick={handleExportExcel}
                disabled={filteredItems.length === 0}
              >
                <i className="fa fa-file-excel me-2"></i>Export Excel
              </button> */}
            </div>
            <div style={{ width: "320px" }}>
              <input
                type="text"
                className="form-control"
                placeholder="Search Ref No, Pax Name, PNR..."
                value={filterText}
                onChange={(e) => setFilterText(e.target.value)}
              />
            </div>
          </div>

          <div ref={tableWrapperRef} className="transaction-table-wrapper">
            
            <DataTable
              columns={visibleColumns}
              data={filteredItems}
              progressPending={loading}
              pagination
              paginationPerPage={10}
              paginationRowsPerPageOptions={[10, 25, 50, 100]}
              customStyles={customStyles}
              highlightOnHover
              responsive
              persistTableHead
              noDataComponent={
                !hasSearched ? (
                  <span className="text-muted">Please enter search criteria and click Search to view transactions.</span>
                ) : (
                  <span className="text-muted">No transactions found</span>
                )
              }
              expandableRows={hiddenColumns.length > 0}
              expandableRowsComponent={ExpandedComponent}
              expandOnRowClicked={false}
              expandableRowsHideExpander={false}
              expandableIcon={{
                collapsed: (
                  <span className="table-plus-icon">+</span>
                ),
                expanded: (
                  <span className="table-plus-icon">−</span>
                )
              }}
            />
          </div>
        </div>
      </section>
    </>
  );
};

export default AllTransactions;
